// src/components/filters/TickerFilterWrapper.jsx
import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TickerMultiSelect from "../misc/TickerMultiSelect";
import TickerPresets from "./TickerPresets";
import { getControlTokens } from "../common/controls";

/**
 * TickerFilterWrapper - Unified wrapper combining TickerMultiSelect and TickerPresets
 *
 * Layout:
 * +------------------------------------+----------+
 * | Filter by Company [chips] ▼        | ★ Favs   |
 * +------------------------------------+----------+
 *
 * @param {object} props
 * @param {array} props.allTickers - All available ticker objects [{ticker, name}, ...]
 * @param {array} props.selectedTickers - Currently selected ticker objects
 * @param {function} props.setSelectedTickers - Setter for selected tickers
 * @param {boolean} props.isAuthenticated - Optional override for auth state (for dev mode)
 */
function TickerFilterWrapper({
  allTickers,
  selectedTickers,
  setSelectedTickers,
  isAuthenticated: isAuthenticatedProp,
  controlContext = 'filterBar',
  width = 180,
  ...otherProps
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, controlContext);
  const resolvedWidth = typeof width === 'number' ? `${width}px` : width;
  const selectWidth = typeof width === 'number'
    ? Math.max(width - tokens.height, tokens.height)
    : undefined;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        border: `1px solid ${tokens.borderColor}`,
        borderRadius: `${tokens.radius}px`,
        overflow: 'hidden',
        height: tokens.height,
        minWidth: resolvedWidth,
        maxWidth: resolvedWidth,
      }}
    >
      <TickerMultiSelect
        allTickers={allTickers}
        selectedTickers={selectedTickers}
        setSelectedTickers={setSelectedTickers}
        leftBorderOnly={true}
        controlContext={controlContext}
        width={selectWidth}
        {...otherProps}
      />
      <TickerPresets
        selectedTickers={selectedTickers}
        setSelectedTickers={setSelectedTickers}
        allTickers={allTickers}
        isAuthenticated={isAuthenticatedProp}
        leftBorderOnly={true}
        controlContext={controlContext}
      />
    </Box>
  );
}

export default TickerFilterWrapper;
